import React from "react";
import styled from "styled-components";
import { theme } from "../../theme";

const ChipStyled = styled.div(
  ({ bigIcon }) => `
  background-color: ${theme.colors.blue};
  border-radius: 50px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px 5px ${bigIcon ? 65 : 30}px;
  position: relative;
`
);

const Icon = styled.img`
  position: absolute;
  top: -3px;
  left: -10px;
`;

export const Chip = ({ icon, bigIcon = false, children }) => {
  return (
    <ChipStyled bigIcon={bigIcon}>
      <Icon src={icon} />
      <span>{children}</span>
    </ChipStyled>
  );
};
